.clouds {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.cloud {
  position: absolute;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  filter: blur(75px);
  animation: drift 24s ease-in-out infinite alternate;
}

.teal {
  background: rgba(42, 102, 128, 0.55);
}

.coral {
  background: rgba(240, 138, 108, 0.35);
  animation-duration: 28s;
}

.cream {
  background: rgba(246, 241, 232, 0.18);
  width: 380px;
  height: 380px;
  animation-duration: 22s;
}

.topRight {
  top: -160px;
  right: -120px;
}

.topLeft {
  top: -160px;
  left: -160px;
}

.bottomLeft {
  bottom: -200px;
  left: -140px;
}

.bottomRight {
  bottom: -200px;
  right: -160px;
}

.midLeft {
  top: 30%;
  left: 30%;
}

@keyframes drift {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(60px, 40px);
  }
}

/* Same break as the app shell; a smaller blur is cheaper to paint on phones. */
@media (max-width: 999px) {
  .cloud {
    width: 320px;
    height: 320px;
    filter: blur(40px);
  }

  .cloud:nth-child(n + 3) {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cloud {
    animation: none;
  }
}
